import React from "react"
import { Form } from "react-bootstrap"
import { blockingFetchService } from "../../../lib/blockingFetch"
import {
  businessDataWithId,
  sortBusinesses,
  validateAmountState,
  validateTextState,
  VALIDATION_TYPE
} from "../../../lib/utils"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import FormControlInlineInput from "../../fragments/FormControl.Inline.Input"
import FormControlInlineSelect from "../../fragments/FormControl.Inline.Select"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import { browserHistory } from "react-router"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../../redux/items/types"
import { connect } from "react-redux"
import FormButtons from "../../fragments/FormButtons"

class FormFinancierBatch extends React.Component {

  constructor(props) {

    super(props)
    const { financierBatch } = this.props,
    isNew = !financierBatch

    this.state = {

      isNew,
      running: false,
      success: false,
      error: null,
      name: isNew ? '' : financierBatch.name,
      transportFee: isNew ? '' : financierBatch.transportFee,
      affiliation: (isNew || !financierBatch.affiliation) ? '' : financierBatch.affiliation.id,

      nameValidationState: VALIDATION_TYPE.NULL,
      affiliationValidationState: VALIDATION_TYPE.NULL,
      transportFeeValidationState: VALIDATION_TYPE.NULL,
    }
  }

  componentDidMount() {

    this.props.loadBusinesses()
    const { isNew } = this.state
    if(!isNew) {
      this.validateAllValues()
    }
  }

  nameChanged = name => this.setState({
    name,
    nameValidationState: validateTextState(name, false),
    error: null,
  })

  affiliationChanged = affiliation => this.setState({
    affiliation,
    affiliationValidationState: validateTextState(affiliation, false),
    error: null,
  })

  transportFeeChanged = transportFee => this.setState({
    transportFee,
    transportFeeValidationState: validateAmountState(transportFee, false),
    error: null,
  })

  validateAllValues = () => {

    const { name, affiliation, transportFee } = this.state,
    nameValid = validateTextState(name, false),
    affiliationValid = validateTextState(affiliation, false),
    transportFeeValid = validateAmountState(transportFee, false)

    this.setState({
      nameValidationState: nameValid,
      affiliationValidationState: affiliationValid,
      transportFeeValidationState: transportFeeValid,
    })

    return nameValid === VALIDATION_TYPE.SUCCESS
      && affiliationValid === VALIDATION_TYPE.SUCCESS
      && transportFeeValid === VALIDATION_TYPE.SUCCESS
  }

  saveClicked = () => {

    if(!this.validateAllValues()) {
      this.setState({ error: 'Some fields are incorrect.' })
      return
    }

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { isNew, name, affiliation, transportFee } = this.state,

    data = { name, transportFee, affiliation: { id: affiliation } },

    { financierBatch } = this.props

    blockingFetchService(
      accessToken => isNew
        ? apiServerApi.createFinancierBatch(accessToken, data)
        : apiServerApi.updateFinancierBatch(accessToken, financierBatch.id, data),
      _ => {
        this.setState({ success: true })
        setTimeout(() => browserHistory.push('/financiers/batches'), 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  renderForm = () => {

    const { isNew, error, success, running, name, affiliation, transportFee, nameValidationState,
      affiliationValidationState, transportFeeValidationState } = this.state,

    { businessesData, financierBatch } = this.props,
    batchName = financierBatch ? financierBatch.name : 'Batch'

    return (
      <div className="simple-form max-width-700 mx-auto mb-20">
        <Form horizontal onSubmit={e => { e.preventDefault(); this.saveClicked()}}>

          <h3 className="text-center">
            { isNew ? 'Create' : 'Update' } { batchName }
          </h3>
          <hr />

          <FormControlInlineInput controlId="name" validationState={ nameValidationState }
            label='Name' placeholder='Enter name' value={ name }
            onChange={ this.nameChanged }
            helpText={ nameValidationState === VALIDATION_TYPE.ERROR ? 'Name is required' : '' }
            disabled={ running }
          />

          <FormControlInlineSelect
            controlId='affiliation' validationState={ affiliationValidationState }
            label='Affiliation' value={ affiliation } 
            onChange={ this.affiliationChanged }
            options={ businessesData }
            withEmptyOption={ true }
            helpText={ affiliationValidationState === VALIDATION_TYPE.ERROR ? 'Choose a business' : '' }
            disabled={ running || !isNew }
          />

          <FormControlInlineInput controlId="transportFee" validationState={ transportFeeValidationState }
            label='Transport fee' placeholder='Enter value' value={ transportFee }
            onChange={ this.transportFeeChanged }
            helpText={ transportFeeValidationState === VALIDATION_TYPE.ERROR ? 'Invalid value' : '' }
            disabled={ running }
          />
        </Form>

        <ProcessesStatus error={ error } running={ running } success={ success } />

        <FormButtons
          onSave={ this.saveClicked }
          onCancel={() => browserHistory.push('/financiers/batches')}
          running={ running }
        />
      </div>
    )
  }

  render() {

    const { isNew } = this.state,
    dataBreadCrumbs = [
      { url: '/financiers', title: 'Financiers' },
      { url: '/financiers/batches', title: 'Batches' }
    ]

    return (
      <div>
        <CustomBreadCrumb activeText={ isNew ? 'New' : 'Update' } data={ dataBreadCrumbs } />
        { this.renderForm() }
      </div>
    )
  }
}

const mapStateToProps = state => {

  const businesses = DckSelectors.selectAllItems(state, ItemTypes.Business)
  sortBusinesses(businesses)

  const businessesData = businessDataWithId(businesses)

  return { businessesData }
},

mapDispatchToProps = dispatch => ({
  loadBusinesses: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.Business)),
})

export default connect(mapStateToProps, mapDispatchToProps)(FormFinancierBatch)



// WEBPACK FOOTER //
// ./src/components/Financiers/Batches/Form.js